import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AppInsightsService } from '../app-insights.service';
import { environment } from 'src/environments/environment';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { IReinstateLedger } from 'src/app/Shared/models/Reinstate';
import { ISaveDeleteResponse } from 'src/app/Shared/interface';
import { IEmailObject, IEmaiLogsList } from 'src/app/Shared/models/EmailSMS';
import {AppService} from '../app.service';


@Injectable({
    providedIn: 'root',
})

export class EmailAndSMSService {
    private baseURL = this.appService.config.apiBaseUrl;
    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService) { }

    composeEmail(emailObjList: IEmailObject[]): Observable<ISaveDeleteResponse[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/EmailAndSMS/ComposeEmails`;
        return this.http.post<ISaveDeleteResponse[]>(url, emailObjList, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    composeSMS(smsObjList): Observable<ISaveDeleteResponse[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/EmailAndSMS/CreateSMS`;
        return this.http.post<ISaveDeleteResponse[]>(url, smsObjList, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    SendEmailToReputationManagement(data): Observable<ISaveDeleteResponse[]> {
        const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        let url = `${this.baseURL}/ReputationManagement/SendEmailToReputationManagement`;
        return this.http.post<ISaveDeleteResponse[]>(url, data, options)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }

    getEmailLogsList(tenantId: number): Observable<IEmaiLogsList[]> {
        debugger
        return this.http.get<IEmaiLogsList[]>(
            `${this.baseURL}/EmailAndSMS/GetAllEmailLogs?tenantId=${tenantId}`,
        { observe: 'response' }).pipe(
            map(res => {
                return res.body as IEmaiLogsList[];
            }),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
